// Roles del sistema
export const ROLES = {
    ADMINISTRADOR: 'administrador',
    CHEF: 'chef',
    PERSONAL_COCINA: 'personal_cocina',
    CLIENTE: 'cliente',
};
// Estados de recetas
export const ESTADOS_RECETA = {
    BORRADOR: 'borrador',
    APROBADA: 'aprobada',
    ARCHIVADA: 'archivada',
};
// Estados de minutas
export const ESTADOS_MINUTA = {
    BORRADOR: 'borrador',
    PUBLICADA: 'publicada',
    CERRADA: 'cerrada',
    ARCHIVADA: 'archivada',
};
// Estados de pedidos
export const ESTADOS_PEDIDO = {
    RESERVADO: 'reservado',
    CONFIRMADO: 'confirmado',
    EN_PREPARACION: 'en_preparacion',
    LISTO: 'listo',
    DESPACHADO: 'despachado',
    CANCELADO: 'cancelado',
};
// Estados de compras
export const ESTADOS_COMPRA = {
    SOLICITADA: 'solicitada',
    PAGADA: 'pagada',
    RECEPCIONADA: 'recepcionada',
    ANULADA: 'anulada',
};
// Tipos de cliente
export const TIPOS_CLIENTE = {
    PARTICULAR: 'persona_natural',
    EMPRESA: 'juridica',
};
// Categorias de ingredientes
export const CATEGORIAS_INGREDIENTE = {
    PROTEICOS: 'proteicos',
    LACTEOS: 'lacteos',
    VERDURAS: 'verduras',
    FRUTAS: 'frutas',
    CEREALES: 'cereales',
    CONDIMENTOS: 'condimentos',
    BEBIDAS: 'bebidas',
    OTROS: 'otros',
};
// Categorias de recetas
export const CATEGORIAS_RECETA = {
    PROTEICO: 'proteico',
    ACOMPANAMIENTO: 'acompanamiento',
    POSTRE: 'postre',
    COLACION_FRIA: 'colacion_fria',
    HIPOCALORICO: 'hipocalorico',
    VEGETARIANO: 'vegetariano',
};
// Tipos de comida
export const TIPOS_COMIDA = {
    ALMUERZO: 'almuerzo',
    CENA: 'cena',
    COLACION: 'colacion',
};
// Configuraciones por defecto
export const CONFIGURACIONES_DEFAULT = {
    STOCK_BAJO_PORCENTAJE: 10,
    STOCK_CRITICO_PORCENTAJE: 5,
    DIAS_ANTELACION_PEDIDOS: 3,
    PORCIONES_BASE_RECETA: 10,
    PORCENTAJE_CONTINGENCIA: 15,
};
// Unidades de medida
export const UNIDADES_MEDIDA = {
    GRAMOS: 'gramos',
    KILOGRAMOS: 'kilogramos',
    LITROS: 'litros',
    MILILITROS: 'mililitros',
    UNIDADES: 'unidades',
    CUCHARADAS: 'cucharadas',
    CUCHARADITAS: 'cucharaditas',
    TAZAS: 'tazas',
};
// =====================================================
// SISTEMA DE ROLES Y PERMISOS DINÁMICOS
// =====================================================
// Módulos del sistema
export const MODULOS_SISTEMA = {
    DASHBOARD: 'dashboard',
    RECETAS: 'recetas',
    MINUTAS: 'minutas',
    ARMAR_PEDIDO: 'armar_pedido',
    PEDIDOS: 'pedidos',
    INGREDIENTES: 'ingredientes',
    LOTES: 'lotes',
    COMPRAS: 'compras',
    PROVEEDORES: 'proveedores',
    COCINA: 'cocina',
    REPORTES_COMPRAS: 'reportes_compras',
    REPORTES: 'reportes',
    MERMAS: 'mermas',
    CLIENTES: 'clientes',
    ADMINISTRACION: 'administracion',
};
// Tipos de permisos (CRUD)
export const PERMISOS = {
    VER: 'ver',
    CREAR: 'crear',
    EDITAR: 'editar',
    ELIMINAR: 'eliminar',
};
// Iconos de lucide-react para cada módulo
export const ICONOS_MODULOS = {
    dashboard: 'Home',
    recetas: 'ChefHat',
    minutas: 'Calendar',
    armar_pedido: 'Clipboard',
    pedidos: 'ClipboardList',
    ingredientes: 'Package',
    lotes: 'Calendar',
    compras: 'ShoppingCart',
    proveedores: 'Building2',
    cocina: 'Utensils',
    reportes_compras: 'TrendingUp',
    reportes: 'BarChart3',
    mermas: 'Trash2',
    clientes: 'Users',
    administracion: 'Settings',
};
// Rutas de cada módulo
export const RUTAS_MODULOS = {
    dashboard: '/dashboard',
    recetas: '/recetas',
    minutas: '/minutas-nuevas',
    armar_pedido: '/armar-pedido',
    pedidos: '/pedidos',
    ingredientes: '/ingredientes',
    lotes: '/lotes',
    compras: '/compras',
    proveedores: '/proveedores',
    cocina: '/cocina',
    reportes_compras: '/reportes-compras',
    reportes: '/reportes',
    mermas: '/mermas',
    clientes: '/clientes',
    administracion: '/admin',
};
